import React from 'react';

// شاشة انتقالية كاملة تظهر عند نجاح تسجيل الدخول لتغطية زمن التحويل إلى لوحة التحكم
export default function AuthSuccessOverlay({ show, title = 'تم تسجيل الدخول بنجاح', subtitle = 'جارٍ تحضير لوحة التحكم...' }) {
  if (!show) return null;
  return (
    <div
      dir="rtl"
      data-testid="auth-success-overlay"
      className="fixed inset-0 z-[1000] flex flex-col items-center justify-center bg-gradient-to-br from-[#0A192F] via-[#0A192F] to-[#0D9488]"
      style={{ animation: 'authOverlayIn 0.25s ease-out' }}
    >
      <div className="relative flex h-24 w-24 items-center justify-center">
        <svg className="absolute inset-0 -rotate-90" viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="46" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="4" />
          <circle
            cx="50" cy="50" r="46" fill="none" stroke="#2dd4bf" strokeWidth="4" strokeLinecap="round"
            strokeDasharray="289"
            style={{ animation: 'authCircleDraw 0.7s ease-out forwards' }}
          />
        </svg>
        <svg viewBox="0 0 24 24" className="h-10 w-10 text-teal-300" fill="none" stroke="currentColor" strokeWidth={3}>
          <path
            strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5"
            strokeDasharray="40"
            style={{ animation: 'authCheckDraw 0.4s 0.55s ease-out forwards', strokeDashoffset: 40 }}
          />
        </svg>
      </div>
      <p className="mt-6 text-lg font-bold text-white" style={{ animation: 'authOverlayIn 0.5s ease-out 0.3s both' }} data-testid="auth-success-title">
        {title}
      </p>
      <p className="mt-1 text-sm text-white/60" style={{ animation: 'authOverlayIn 0.5s ease-out 0.45s both' }}>
        {subtitle}
      </p>
    </div>
  );
}
